import { Group, Navbar, ScrollArea, createStyles, rem } from "@mantine/core";

import {
  IconCalendarStats,
  IconFileAnalytics,
  IconGauge,
  IconLock,
  IconNotes,
  IconPresentationAnalytics,
} from "@tabler/icons-react";

import { IconMap2 } from "@tabler/icons-react";

import { LinksGroup } from "./components/LinksGroup";

import { userState } from "pages/Login/atom/userState";
import { useRecoilState } from "recoil";

function SRD_Navbar() {
  const [user] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const gradmin = (level === 1) ? true : false;
  const adminLevel = [0].includes(level);
  const isAdminOrGradmin = adminLevel || gradmin;

  const navbarData = [
    {
      label: "Home",
      icon: IconGauge,
      initiallyOpened: false,
      links: [
        { label: "장치 지도", link: "/home_map" },
        { label: "일괄 분사", link: "/batch_control" },
        { label: "현장 관제", link: "/home" },
      ],
    },
    {
      label: "차트",
      icon: IconNotes,
      initiallyOpened: false,
      link:  "/chart",
    },
    {
      label: "상태 이력",
      icon: IconNotes,
      initiallyOpened: false,
      link: "/detail_history",
    },
    {
      label: "제어 이력",
      icon: IconNotes,
      initiallyOpened: false,
      link:  "/control_history",
    },
    {
      label: "SMS",
      icon: IconCalendarStats,
      links: [
        { label: "발송 리스트", link: "/sms/list" },
        { label: "수신자 관리", link: "/sms/receive" },
        ...(isAdminOrGradmin
          ? [{ label: "알람 항목 관리", link: "/sms/item" }]
          : []),
      ],
    },
    {
      label: "매뉴얼",
      icon: IconPresentationAnalytics,
      initiallyOpened: false,
      link: "/manual",
    },
    { label: "마이페이지", icon: IconFileAnalytics, link: "/mypage" },
    {
      label: "관리자",
      icon: IconLock,
      links: [
        { label: "장치 관리", link: "/admin/device" },
        { label: "현장 관리", link: "/admin/site" },
        { label: "현장 편집", link: "/admin/site_edit" },
        { label: "사용자 관리", link: "/admin/user" },
        { label: "매뉴얼 관리", link: "/admin/manual" },
        { label: "라이브러리 관리", link: "/admin/library" },
        ...(adminLevel
          ? [
              { label: "그룹 관리", link: "/admin/group" },
              { label: "변경이력 조회", link: "/admin/change_log" },
            ]
          : []),
      ],
    },
    ...(adminLevel
      ? [
          {
            label: "고속도로 정보 조회",
            icon: IconMap2,
            link: "/highway",
          },
        ]
      : []),
  ];

  const { classes } = useStyles();

  const links = navbarData
    .filter((item) => {
      if (item.label === "관리자") {
        return isAdminOrGradmin; // adminLevel 또는 gradmin일 때 관리자 메뉴 표시
      }
      if (item.label === "SMS") {
        return true; // SMS 메뉴는 항상 표시
      }
      return true; // 나머지 메뉴 항목은 모두 표시
    })
    .map((item) => (
      <LinksGroup {...item} initiallyOpened={true} key={item.label} />
    ));

  return (
    <Navbar
      height={"100%"}
      width={{ sm: 230 }}
      p="md"
      className={classes.navbar}
    >
      <Navbar.Section className={classes.header}>
        <Group position="apart" style={{ height: "25px" ,
              fontSize: 14,
              background: "white",
              textAlign:"center",
            }}>
          <div>
            [ {user.fn_name} ] <br></br>
            {user.fn_group_nm}({user.fn_group_id.length < 2 ? '0'+user.fn_group_id : user.fn_group_id})
          </div>
        </Group>
      </Navbar.Section>

      <Navbar.Section grow className={classes.links} component={ScrollArea}>
        <div className={classes.linksInner}>{links}</div>
      </Navbar.Section>

      <Navbar.Section className={classes.footer}></Navbar.Section>
    </Navbar>
  );
}

export default SRD_Navbar;

const useStyles = createStyles((theme) => ({
  navbar: {
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    paddingBottom: 0,
  },

  header: {
    padding: theme.spacing.md,
    paddingTop: 0,
    marginLeft: `calc(${theme.spacing.md} * -1)`,
    marginRight: `calc(${theme.spacing.md} * -1)`,
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    borderBottom: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,
  },

  links: {
    marginLeft: `calc(${theme.spacing.md} * -1)`,
    marginRight: `calc(${theme.spacing.md} * -1)`,
  },

  linksInner: {
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
  },

  footer: {
    marginLeft: `calc(${theme.spacing.md} * -1)`,
    marginRight: `calc(${theme.spacing.md} * -1)`,
    borderTop: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,
  },
}));
